import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { http } from '../../redux/http';

import {
  CategoryContainer, /*BarContainer, RewardText, RewardLevel,*/
  Layout, /*RightArrow,*/ NewProgressContent, /* MainBarLineProgressPoint, RealProgressPoint,*/ ProgressBar, /*BarContent,*/ MainProgressBar, PointContent, ImageTag, /*BronzeImg, SilverImg, GoldImg, FirstClass, SecondClass, ThirdClass, FourClass, Bronze, Silver, Gold, Finished, FlagImg, NewProgressCardV2,*/
  // NewProgressCard,
  NewProgressPoints,
  TrophyImg,
  TrophyLabel,
  TrophyPoints,
  NewProgressCardV1
} from '../../containers/Rewards/newRewardDataStyles';
import { ImageUrl } from '../../utils/constants';
import { commaSeperator, fetchApi } from '../../utils/methods';
import { Waiting } from '../../components';
import { getCompanyRewardTierAPI } from '../../redux/actions';
//import RewardsCategory from './RewardsCategory';
import { withTranslation } from 'react-i18next';
import NewRewardCatagory from '../../containers/Rewards/NewRewardCatagory';
import _, { isEmpty, isNull, isUndefined } from 'lodash';
import { ViewPointsDetails } from '../../containers/Rewards/styles';
import moment from 'moment';
import { getHistoryRewardPoints, getUserRewardHistoryDetails } from '../../redux/actions/wellnessDashboardActions';
import CompanyRewardsV2 from '../PersonalProfile/CompanyRewardsV2';
// import { NewProgressPointsV2, /*TabButton*/ } from './styles';
import LazyImage from '../common/LazyImage/LazyImage';
import NewRewardData from '../../containers/Rewards/NewRewardData';
import { TopContainerWrapper } from '../Recognition/RecognitionActivity/styles';
import { BorderBottom, TabBottomLine } from '../RecogntionAdmin/styles';
import { TabsWrapper } from '../common/commonStyles';
import { OuterCardWrapper } from './styles';
import { TIER_STYLES } from '../../../mockData';
import RewardDetailsPage from '../../containers/Rewards/RewardDetailsPage';
import CompanyRewardDetails from '../../containers/companyDetails/CompanyRewardDetails';
// import CompanyRewardsV2 from './CompanyRewardsV2';
import {GetUserProfile} from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import CongratulationPopup from './CongratulationPopup';
import Congrats from './CongrartsBackdrop';
import BucketCaps from './BucketCaps';

class UserAcheivementData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 3,
      firstIndex: 0,
      secondIndex: 0,
      showCongratsOverlay: false,
      viewDetail: false,
      year: moment().format('YYYY'),
      years: [],
      dropDown: -1,
      rewardData: [],
      userProfileDetails:null,
    }
  }

  setActiveTab = (active) => {
    this.setState({ selectedTab: active })
  }


  componentDidUpdate(prevProps) {
    if (
      this.props.user?.spot_point_notify === 1 &&
      prevProps.user?.spot_point_notify !== 1
    ) {
      this.setState({ showCongratsOverlay: true });
    }
  }


  // handleCloseCongrats = () => {
  //   window.console.log("indisieeiei")
  //   this.setState({ showCongratsOverlay: false });



  
  //   // if you need API call or redux action
  //   // this.props.clearSpotPointNotification();
  // };


  closeCongrats = () => {
    this.setState({ showCongratsOverlay: false });
  }



  

  FetchComanyProfileDetails = async () => {
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const profileRes = await fetchApi(`${GetUserProfile}`, 'GET');
      const rewardRes = await http.get('/v1/get-user-reward-details', { headers: { AUTHTOKEN: AuthToken } });
      if (profileRes.status === 'success') {
        const companyDetails = profileRes.data.company_details;
        companyDetails.is_cap_enabled = rewardRes?.is_cap_enabled || false;
        companyDetails.reward_period_id = rewardRes?.reward_period_id;
        this.setState({ userProfileDetails: companyDetails });
      } else {
        toast.error(profileRes.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  };





  

  componentDidMount() {

    

    this.setState({
      firstIndex: 10,
      secondIndex: 5,
    });
    const { getCompanyRewardTierAPI, companyId, getHistoryRewardPoints, getUserRewardHistoryDetails, userId, created_at } = this.props;
    // const { year } = this.state;
    this.FetchComanyProfileDetails();
    getCompanyRewardTierAPI(companyId);
    const currentYear = new Date().getFullYear();
    let yearArray = [];
    let created = created_at?new Date(created_at.created_at).getFullYear():new Date("2016").getFullYear()
    for (let i = currentYear; i >= created; i--) {
      yearArray.push(i);
      getHistoryRewardPoints(userId, i)
      getUserRewardHistoryDetails(userId, i)
    }
    this.setState({
      years: yearArray,
      rewardData: this.props.rewardData
    })

    if (this.props.user?.spot_point_notify === 1) {
      this.setState({ showCongratsOverlay: true });
    }
  }

  handleDetails = (index) => {
    if (this.state.dropDown === index) {
      this.setState({ dropDown: -1 })
    } else {
      this.setState({ dropDown: index })
    }
  }

  categoryArray = (index) => {
    const { rewardData, userRewardHistoryDetails } = this.props;
    let sortedData = rewardData.sort(
      (y1, y2) => (y1.year < y2.year) ? 1 : (y1.year > y2.year) ? -1 : 0);
    let sorteduserRewardHistoryDetails = userRewardHistoryDetails.sort(
      (y1, y2) => (y1.year < y2.year) ? 1 : (y1.year > y2.year) ? -1 : 0);
    return [
      {
        src: 'Fitness_points_bg',
        title: 'Fitness Points',
        availalePoint: !_.isUndefined(sortedData?.[index]?.data) ? sortedData?.[index]?.data?.max_fitness : 0,
        earnPoint: !_.isUndefined(sortedData?.[index]?.data) ? sortedData?.[index]?.data?.fitness_point : 0,
        percentage: !_.isUndefined(sortedData?.[index]?.data) ? sortedData?.[index]?.data?.fitness_percentage : 0,
        maxAvailableFitnessPoint: !_.isUndefined(sortedData?.[index]?.data) ? sortedData?.[index]?.data?.max_fitness_points : 0,
        details: !_.isUndefined(sorteduserRewardHistoryDetails?.[index]?.data) ? sorteduserRewardHistoryDetails?.[index]?.data?.fitness : [],
        bonus: !_.isUndefined(sorteduserRewardHistoryDetails?.[index]?.data) ? sorteduserRewardHistoryDetails?.[index]?.data?.bonus_fitness : [],
      },
      {
        src: 'Social_Points_bg',
        title: 'Social Points',
        availalePoint: !_.isUndefined(sortedData?.[index]?.data) ? sortedData?.[index]?.data?.max_social : 0,
        earnPoint: !_.isUndefined(sortedData?.[index]?.data) ? sortedData?.[index]?.data?.social_point : 0,
        percentage: !_.isUndefined(sortedData?.[index]?.data) ? sortedData?.[index]?.data?.social_percentage : 0,
        details: !_.isUndefined(sorteduserRewardHistoryDetails?.[index]?.data) ? sorteduserRewardHistoryDetails?.[index]?.data?.social : [],
        bonus: !_.isUndefined(sorteduserRewardHistoryDetails?.[index]?.data) ? sorteduserRewardHistoryDetails?.[index]?.data?.bonus_social : [],
      },
      {
        src: 'healthAssessment_points_bg',
        title: 'Health Assessment Points',
        availalePoint: !_.isUndefined(sortedData?.[index]?.data) ? sortedData?.[index]?.data?.max_wellness : [],
        earnPoint: !_.isUndefined(sortedData?.[index]?.data) ? sortedData?.[index]?.data?.wellness_point : 0,
        percentage: !_.isUndefined(sortedData?.[index]?.data) ? sortedData?.[index]?.data?.wellness_percentage : 0,
        details: !_.isUndefined(sorteduserRewardHistoryDetails?.[index]?.data) ? sorteduserRewardHistoryDetails?.[index]?.data?.wellness : [],
        bonus: !_.isUndefined(sorteduserRewardHistoryDetails?.[index]?.data) ? sorteduserRewardHistoryDetails?.[index]?.data?.bonus_wellness : [],
      },
      {
        src: 'Wellness_points_bg',
        title: 'Wellness Points',
        availalePoint: !_.isUndefined(sortedData?.[index]?.data) ? sortedData?.[index]?.data?.max_education : 0,
        earnPoint: !_.isUndefined(sortedData?.[index]?.data) ? sortedData?.[index]?.data?.education_point : 0,
        percentage: !_.isUndefined(sortedData?.[index]?.data) ? sortedData?.[index]?.data?.education_percentage : 0,
        details: !_.isUndefined(sorteduserRewardHistoryDetails?.[index]) ? sorteduserRewardHistoryDetails?.[index]?.data?.education : [],
        bonus: !_.isUndefined(sorteduserRewardHistoryDetails?.[index]?.data) ? sorteduserRewardHistoryDetails?.[index]?.data?.bonus_education : [],
      }
    ]
  }


  render() {
    const { rewardData, t, companyRewardsBarValues, userId,userCompany, history,brandingColor,reward } = this.props;
    const { selectedTab,userProfileDetails  } = this.state;
    if (!rewardData || _.isUndefined(companyRewardsBarValues) || isUndefined(rewardData) || isNull(rewardData) || isEmpty(rewardData)) {
      return <Waiting />
    }
    let finishPoint = companyRewardsBarValues?.finished;
    const bronzePoints = !_.isUndefined(companyRewardsBarValues.bronze) ? companyRewardsBarValues.bronze : 0;
    const silverPoints = !_.isUndefined(companyRewardsBarValues.silver) ? companyRewardsBarValues.silver : 0;
    const goldPoints = !_.isUndefined(companyRewardsBarValues.gold) ? companyRewardsBarValues.gold : 0;
    // const bronze = bronzePoints / finishPoint * 100;
    // const silver = silverPoints / finishPoint * 100;
    // const gold = goldPoints / finishPoint * 100;
    let sortedData = rewardData.sort(
      (y1, y2) => (y1.year < y2.year) ? 1 : (y1.year > y2.year) ? -1 : 0);
    // const { monthlyRewardPoint } = this.props;
    // const date = new Date();
    // const month = findMonth(date.getMonth());
    // let progressData = {};
    // progressData.point = rewardData.total === 10000 ? finishPoint : rewardData.total > 10000 ? finishPoint : rewardData.total >= goldPoints + 1 ? 10000 - rewardData.total : rewardData.total >= silverPoints + 1 ? (goldPoints + 1) - rewardData.total : rewardData.total < bronzePoints ? bronzePoints - rewardData.total : (silverPoints + 1) - rewardData.total;
    // progressData.level = rewardData.total > 10000 ? '' : rewardData.total < bronzePoints ? 'bronze' : rewardData.total < silverPoints + 1 ? 'silver' : rewardData.total < goldPoints + 1 ? 'gold' : rewardData.total < finishPoint ? 'Finished' : rewardData.total === finishPoint ? 'Finished' : '';
    // console.log('createe', this.props.userRewardHistoryDetails)
    // let created = new Date(created_at).getFullYear()
    // const points = reward.total;

    let arr = []
    if(sortedData && sortedData.length) {
      arr.push(sortedData[0])
    }
    if(sortedData && sortedData.length) {
      sortedData.map((n)=>{
        let d = false
        if(arr && arr.length) {
          arr.map((i)=>{
            if(n && i) {
              if(n["year"] == i["year"]) {
                d = true
              }
            }
          })
          if(!d) {
            arr.push(n)
          }
        }
      })
    }
    sortedData = arr;

    const getProgressWidth = (earnedPoints) => {
      // BRONZE
      if (earnedPoints < bronzePoints) {
        return (earnedPoints / bronzePoints) * 3.5;
      }
    
      // SILVER (Bronze earned)
      if (earnedPoints < silverPoints) {
        return (
          10.7 +
          ((earnedPoints - bronzePoints) / (silverPoints - bronzePoints)) *
            (32.9 - 10.7)
        );
      }
    
      // GOLD (Silver earned)
      if (earnedPoints < goldPoints) {
        return (
          40.4 +
          ((earnedPoints - silverPoints) / (goldPoints - silverPoints)) *
            (62 - 40.4)
        );
      }
    
      // PLATINUM (Gold earned)
      if (earnedPoints < finishPoint) {
        return (
          70 +
          ((earnedPoints - goldPoints) / (finishPoint - goldPoints)) *
            (93 - 70)
        );
      }
    
      // PLATINUM earned
      return 100;
    };
    // const progressWidth = Math.min(Math.max(getProgressWidth(), 0), 100);
    // const lang = localStorage.getItem('lang');

    const earnedPoints=Number(sortedData?.[0].data.total) || 0;
    const userTier = earnedPoints >= companyRewardsBarValues?.finished ? 'finished' : earnedPoints >= companyRewardsBarValues?.gold ? 'gold' : earnedPoints >= companyRewardsBarValues?.silver ? 'silver' : earnedPoints >= companyRewardsBarValues?.bronze ? 'bronze' :earnedPoints >= companyRewardsBarValues?.silver ? 'none' : null;

    const tierKey = userTier || 'none';
    const tierStyleTopCard = TIER_STYLES[tierKey] || TIER_STYLES?.none;  
    const SpotPointsEarned = this.props.user?.recent_spot_points;
    const SpotPointsDescription = this.props.user?.recent_spot_points_description;
    const UserName = this.props.user?.fname;


   
    return (
     
      <div>
        {/* <TabsWrapper background padding="15px 0 25px 0">
          <TabButton id={this.props.t("Points")} active={selectedTab==3} onClick={()=>this.setActiveTab(3)}>
            {this.props.t("Experience Points")}
          </TabButton>
          <TabButton id={this.props.t("Points")} active={selectedTab==1} onClick={()=>this.setActiveTab(1)}>
            {this.props.t("History")}
          </TabButton>
          <TabButton id={this.props.t("Company Rewards")} active={selectedTab==2} onClick={()=>this.setActiveTab(2)}>
            {this.props.t("Company Rewards")}
          </TabButton>
        </TabsWrapper> */}

        <TopContainerWrapper style={{ flexWrap: "wrap" }}>
          <TabsWrapper background="transparent" padding="15px 0px">
            <TabBottomLine background={brandingColor} active={selectedTab==3} onClick={()=>this.setActiveTab(3)}>
              {this.props.t("Experience Points")}
              <BorderBottom active={selectedTab==3} background={brandingColor} />
            </TabBottomLine>
            {userProfileDetails?.is_cap_enabled && (
              <TabBottomLine background={brandingColor} active={selectedTab==4} onClick={()=>this.setActiveTab(4)}>
                {this.props.t("Point Buckets")}
                <BorderBottom active={selectedTab==4} background={brandingColor} />
              </TabBottomLine>
            )}
            <TabBottomLine background={brandingColor} active={selectedTab==2} onClick={()=>this.setActiveTab(2)}>
              {this.props.t("Company Rewards")}
              <BorderBottom active={selectedTab==2} background={brandingColor} />
            </TabBottomLine>


            {/* <TabBottomLine background={brandingColor}  active={selectedTab==1} onClick={()=>this.setActiveTab(1)}>
              {this.props.t("History")}
              <BorderBottom active={selectedTab==1} background={brandingColor} />
            </TabBottomLine> */}
          </TabsWrapper>
        </TopContainerWrapper> 

        {selectedTab === 1 ?
          <div>
            {sortedData.length &&
              <React.Fragment>
                {/* <div style={{ fontSize: '18px', fontFamily: 'rubik-medium', color: '#0D4270' }}>{this.props.t("Current Year")} {sortedData[0].year}</div> */}
                <OuterCardWrapper>{this.props.t("Current Year")} {sortedData[0].year}</OuterCardWrapper>
                <Layout id={'CurrentYear'}>
                  {/* <NewProgressCardV2>
                    <NewProgressContent>
                      <div className='main_content'>
                        {sortedData[0].data.total >= 0 &&
                          <div className="newImageData">
                            <ImageTag>
                              <img src={sortedData[0].data.total > goldPoints ? `${imgPath}/NewRewardSection/gold_bg_img.png` : sortedData[0].data.total > silverPoints ? `${imgPath}/NewRewardSection/slivers_bg_img.png` : sortedData[0].data.total > bronzePoints ? `${imgPath}/NewRewardSection/bronze_bg_img.png` : sortedData[0].data.total === 0 ? `${imgPath}/NewRewardSection/no_BadgeImg.png` : `${imgPath}/NewRewardSection/no_BadgeImg.png`} />
                            </ImageTag>
                          </div>
                        }
                        <div className='main_point_class'>
                          <div className='point_class'>
                            <div className='total_value'>{t("Total Points")}</div>
                            <div className='total_point_value' style={{ marginBottom: '10px' }}>{commaSeperator(sortedData[0].data.total)}</div>
                            <div className='border_line' />
                            <div className='left_point' style={{ marginTop: '15px' }}><span className='earn_point'>{this.props.t('Year')+' ' + (sortedData.length - 0)} - </span>{sortedData[0].year}</div>
                          </div>
                        </div>
                      </div>
                    </NewProgressContent>
                    <NewProgressPointsV2>
                      <MainProgressBar>
                        <ProgressBar width={sortedData[0].data.total <= finishPoint ? sortedData[0].data.total * 100 / finishPoint : 100} color={sortedData[0].data.total > silverPoints ? "#DCC34C" : sortedData[0].data.total > bronzePoints ? "#B9C1C6" : "#A57576"}>
                          <div className="progrss" />
                          <BronzeImg width={sortedData[0].data.total > bronzePoints ? '100%' : '100%'} imageWidth={(sortedData[0].data.total > bronzePoints + 1) || (sortedData[0].data.total === bronzePoints) ? '1' : ''} left={sortedData[0].data.total < bronzePoints ? `calc(${bronze}% - 38px)` : `calc(${bronze}% - 60px)`} top={(sortedData[0].data.total === 0 && '-27px') || (sortedData[0].data.total < bronzePoints ? '-65px' : '-77px')}>
                            <Bronze paddingLeft={sortedData[0].data.total < bronzePoints ? '-5px' : '5px'} paddingBottom={sortedData[0].data.total < bronzePoints ? '10px' : '6px'}>{t("Bronze")}</Bronze>
                            <LazyImage src={`${ImageUrl}/images/Rewards/bronze.png`} />
                            <FirstClass marginTop={sortedData[0].data.total < bronzePoints ? '10px' : '5px'} paddingLeft={sortedData[0].data.total < bronzePoints ? 'none' : '2px'} marginLeft={sortedData[0].data.total < bronzePoints ? '-5px' : 'none'}>{commaSeperator(bronzePoints)}{this.props.t("pts")}</FirstClass>
                          </BronzeImg>
                          <SilverImg width={sortedData[0].data.total > silverPoints ? '100%' : '100%'} imageWidth={(sortedData[0].data.total > silverPoints + 1) || (sortedData[0].data.total === silverPoints) ? '1' : ''} left={sortedData[0].data.total < silverPoints ? `calc(${silver}% - 35px)` : `calc(${silver}% - 60px)`} top={(sortedData[0].data.total === 0 && '-152px') || (sortedData[0].data.total < silverPoints ? '-190px' : '-201px')}>
                            <Silver paddingLeft={sortedData[0].data.total < silverPoints ? '2px' : '10px'} paddingBottom={sortedData[0].data.total < silverPoints ? '10px' : '6px'}>{t("Silver")}</Silver>
                            <LazyImage src={`${ImageUrl}/images/Rewards/silver.png`} />
                            <SecondClass marginTop={sortedData[0].data.total < silverPoints ? '12px' : '8px'} paddingLeft={sortedData[0].data.total < silverPoints ? 'none' : '2px'} marginLeft={sortedData[0].data.total < silverPoints ? '-5px' : 'none'}>{commaSeperator(silverPoints)}{this.props.t("pts")}</SecondClass>
                          </SilverImg>
                          <GoldImg width={sortedData[0].data.total > goldPoints ? '100%' : '100%'} imageWidth={(sortedData[0].data.total > goldPoints + 1) || (sortedData[0].data.total === goldPoints) ? '1' : ''} left={sortedData[0].data.total < goldPoints ? `calc(${gold}% - 35px)` : `calc(${gold}% - 60px)`} top={(sortedData[0].data.total === 0 && '-275px') || (sortedData[0].data.total < goldPoints ? '-314px' : '-324px')}>
                            <Gold paddingLeft={sortedData[0].data.total < goldPoints ? '2px' : '10px'} paddingBottom={sortedData[0].data.total < goldPoints ? '10px' : '6px'}>{t("Gold")}</Gold>
                            <LazyImage src={`${ImageUrl}/images/Rewards/gold.png`} />
                            <ThirdClass marginTop={sortedData[0].data.total < goldPoints ? '10px' : '5px'} paddingLeft={sortedData[0].data.total < goldPoints ? 'none' : '2px'} marginLeft={sortedData[0].data.total < goldPoints ? '-5px' : 'none'}>{commaSeperator(goldPoints)}{this.props.t("pts")}</ThirdClass>
                          </GoldImg>
                          <FlagImg top={sortedData[0].data.total === 0 ? '-400px' : '-445px'} left={`calc(100% - ${ lang == 'fr' ? '50px' : '35px'})`}>
                            <Finished>{t("Finish")}</Finished>
                            <LazyImage src={`${ImageUrl}/images/NewRewardSection/finish-flag.png`} />
                            <FourClass>{commaSeperator(companyRewardsBarValues.finished)}{this.props.t("pts")}</FourClass>
                          </FlagImg>
                        </ProgressBar>
                      </MainProgressBar>
                      <ViewPointsDetails onClick={() => this.handleDetails(0)}>
                        <div>{this.props.t("View Point Details")}
                          {this.state.dropDown === 0 ? <img src='/public/images/viewUpArrow.png'></img> : <img src='/public/images/viewDownArrow.png'></img>}
                        </div>
                      </ViewPointsDetails>
                      <PointContent />
                    </NewProgressPointsV2>
                  </NewProgressCardV2> */}
                  <NewProgressCardV1 isBorder={"none"}>
                    <NewProgressContent isBorderRadius={"0px"} tierStyle={tierStyleTopCard}>
                      <div className='main_content'>
                        { sortedData[0].data.total >= 0 &&
                      <div className="newImageData">
                        <ImageTag>
                          <LazyImage src={sortedData[0].data.total >= companyRewardsBarValues.finished ?  `${ImageUrl}/images/Rewards/new-platinum.png` : sortedData[0].data.total > goldPoints ? `${ImageUrl}/images/Rewards/new-gold.png` : sortedData[0].data.total > silverPoints ? `${ImageUrl}/images/Rewards/new-silver.png` :  sortedData[0].data.total > bronzePoints ? `${ImageUrl}/images/Rewards/new-bronze.png` : `${ImageUrl}/images/Rewards/new-no-badge.png` }/>
                        </ImageTag>
                      </div> 
                        }
                        <div className='main_point_class'>
                          <div className='point_class'>
                            <div className='total_value'>{t("Total Points")}</div>
                            <div className='total_point_value' style={{ marginBottom: '10px' }}>{commaSeperator(sortedData[0].data.total)}</div>
                            {/* <div className='border_line' /> */}
                            <div className='left_point' style={{ marginTop: '15px' }}><span className='earn_point'>{this.props.t('Year')+' ' + (sortedData.length - 0)} - </span>{sortedData[0].year}</div>
                          </div>
                        </div>
                      </div>
                    </NewProgressContent>
                    <NewProgressPoints style={{position:'relative'}}>
                      <MainProgressBar style={{position:'absolute',display:'flex', height:'100%',top:'15%'}}>
                        <ProgressBar 
                          width={Math.min(Math.max(getProgressWidth(reward.total), 0), 100)}
                          // width={sortedData[0].data.total <= 10000 ? sortedData[0].data.total * 100 / 10000 : 100} 
                          color={"#DA6C74"}>
                          <div className="progrss" />
                        </ProgressBar>
                      </MainProgressBar>
                      <div className="medals-container">
        
                        <TrophyImg margin={'0px 0px 0px 25px'}>
                          <LazyImage div={'image-container'} src={`${ImageUrl}/images/Rewards/new-bronze.png`} />
                          <TrophyLabel>Bronze</TrophyLabel>
                          <TrophyPoints>{commaSeperator(bronzePoints)} pts </TrophyPoints>
                        </TrophyImg>
        
                        <TrophyImg>
                          <LazyImage div={'image-container'} src={`${ImageUrl}/images/Rewards/new-silver.png`} />
                          <TrophyLabel>Silver</TrophyLabel>
                          <TrophyPoints>{commaSeperator(silverPoints)} pts</TrophyPoints>
                        </TrophyImg>
        
                        <TrophyImg>
                          <LazyImage div={'image-container'} src={`${ImageUrl}/images/Rewards/new-gold.png`} />
                          <TrophyLabel>Gold </TrophyLabel>
                          <TrophyPoints>{commaSeperator(goldPoints)} pts</TrophyPoints>
                        </TrophyImg>
        
                        <TrophyImg margin={'0px -3px 0px 0px'}>
                          <LazyImage div={'image-container'} src={`${ImageUrl}/images/Rewards/new-platinum.png`} />
                          <TrophyLabel>Platinum</TrophyLabel>
                          <TrophyPoints>{commaSeperator(companyRewardsBarValues.finished)} pts</TrophyPoints>
                        </TrophyImg>
        
                      </div>
                      <PointContent />
                      <ViewPointsDetails onClick={() => this.handleDetails(0)} style={{top:'17px', left:'-39px'}}>
                        <div>{this.props.t("View Point Details")}
                          {this.state.dropDown === 0 ? <img src='/public/images/viewUpArrow.png'></img> : <img src='/public/images/viewDownArrow.png'></img>}
                        </div>
                      </ViewPointsDetails>
                    </NewProgressPoints>
                  </NewProgressCardV1>
                  {this.state.dropDown === 0 && <CategoryContainer>
                    {this.categoryArray(sortedData.indexOf(sortedData[0])).map((category, index) => (
                      <NewRewardCatagory category={category} key={index} history={this.props.history} getIndex={index} />
                    ))}
                  </CategoryContainer>}
                </Layout>
              </React.Fragment>}
            {/* <div style={{ fontSize: '18px', fontFamily: 'rubik-medium', color: '#0D4270' }}>{this.props.t("Past Years")}</div> */}
            <OuterCardWrapper>{this.props.t("Past Years")}</OuterCardWrapper>
            {sortedData.length && sortedData.map((dataRewards, index) => {

              const earnedPoints=Number(dataRewards.data.total) || 0;
              const userTier = earnedPoints >= companyRewardsBarValues?.finished ? 'finished' : earnedPoints >= companyRewardsBarValues?.gold ? 'gold' : earnedPoints >= companyRewardsBarValues?.silver ? 'silver' : earnedPoints >= companyRewardsBarValues?.bronze ? 'bronze' :earnedPoints >= companyRewardsBarValues?.silver ? 'none' : null;
    
              const tierKey = userTier || 'none';
              const tierStyle = TIER_STYLES[tierKey] || TIER_STYLES?.none;

              {/* window.console.log("tierKey index achievement",tierKey , index) */}
              
              return(
                index > 0 && <Layout key={index} id={'PastYear'}>
                  {/* <NewProgressCardV2>
                    <NewProgressContent>
                      <div className='main_content'>
                        {dataRewards.data.total >= 0 &&
                          <div className="newImageData">
                            <ImageTag>
                              <img src={dataRewards.data.total > goldPoints ? `${imgPath}/NewRewardSection/gold_bg_img.png` : dataRewards.data.total > silverPoints ? `${imgPath}/NewRewardSection/slivers_bg_img.png` : dataRewards.data.total > bronzePoints ? `${imgPath}/NewRewardSection/bronze_bg_img.png` : dataRewards.data.total === 0 ? `${imgPath}/NewRewardSection/no_BadgeImg.png` : `${imgPath}/NewRewardSection/no_BadgeImg.png`} />
                            </ImageTag>
                          </div>
                        }
                        <div className='main_point_class'>
                          <div className='point_class'>
                            <div className='total_value'>{t("Total Points")}</div>
                            <div className='total_point_value' style={{ marginBottom: '10px' }}>{commaSeperator(dataRewards.data.total)}</div>
                            <div className='border_line' />
                            <div className='left_point' style={{ marginTop: '15px' }}><span className='earn_point'>{this.props.t('Year')+' ' + (sortedData.length - index)} - </span>{dataRewards.year}</div>
                          </div>
                        </div>
                      </div>
                    </NewProgressContent>
                    <NewProgressPointsV2>
                      <MainProgressBar>
                        <ProgressBar width={sortedData[index].data.total <= finishPoint ? sortedData[index].data.total * 100 / finishPoint : 100} color={sortedData[index].data.total > silverPoints ? "#DCC34C" : sortedData[index].data.total > bronzePoints ? "#B9C1C6" : "#A57576"}>
                          <div className="progrss" />
                          <BronzeImg width={sortedData[index].data.total > bronzePoints ? '100%' : '100%'} imageWidth={(sortedData[index].data.total > bronzePoints + 1) || (sortedData[index].data.total === bronzePoints) ? '1' : ''} left={sortedData[index].data.total < bronzePoints ? `calc(${bronze}% - 38px)` : `calc(${bronze}% - 60px)`} top={(sortedData[index].data.total === 0 && '-27px') || (sortedData[index].data.total < bronzePoints ? '-65px' : '-77px')}>
                            <Bronze paddingLeft={sortedData[index].data.total < bronzePoints ? '-5px' : '5px'} paddingBottom={sortedData[index].data.total < bronzePoints ? '10px' : '6px'}>{t("Bronze")}</Bronze>
                            <LazyImage src={`${ImageUrl}/images/Rewards/bronze.png`} />
                            <FirstClass marginTop={sortedData[index].data.total < bronzePoints ? '10px' : '5px'} paddingLeft={sortedData[index].data.total < bronzePoints ? 'none' : '2px'} marginLeft={sortedData[index].data.total < bronzePoints ? '-5px' : 'none'}>{commaSeperator(bronzePoints)}{this.props.t("pts")}</FirstClass>
                          </BronzeImg>
                          <SilverImg width={sortedData[index].data.total > silverPoints ? '100%' : '100%'} imageWidth={(sortedData[index].data.total > silverPoints + 1) || (sortedData[index].data.total === silverPoints) ? '1' : ''} left={sortedData[index].data.total < silverPoints ? `calc(${silver}% - 35px)` : `calc(${silver}% - 60px)`} top={(sortedData[index].data.total === 0 && '-152px') || (sortedData[index].data.total < silverPoints ? '-190px' : '-201px')}>
                            <Silver paddingLeft={sortedData[index].data.total < silverPoints ? '2px' : '10px'} paddingBottom={sortedData[index].data.total < silverPoints ? '10px' : '6px'}>{t("Silver")}</Silver>
                            <LazyImage src={`${ImageUrl}/images/Rewards/silver.png`} />
                            <SecondClass marginTop={sortedData[index].data.total < silverPoints ? '12px' : '8px'} paddingLeft={sortedData[index].data.total < silverPoints ? 'none' : '2px'} marginLeft={sortedData[index].data.total < silverPoints ? '-5px' : 'none'}>{commaSeperator(silverPoints)}{this.props.t("pts")}</SecondClass>
                          </SilverImg>
                          <GoldImg width={sortedData[index].data.total > goldPoints ? '100%' : '100%'} imageWidth={(sortedData[index].data.total > goldPoints + 1) || (sortedData[index].data.total === goldPoints) ? '1' : ''} left={sortedData[index].data.total < goldPoints ? `calc(${gold}% - 35px)` : `calc(${gold}% - 60px)`} top={(sortedData[index].data.total === 0 && '-275px') || (sortedData[index].data.total < goldPoints ? '-314px' : '-324px')}>
                            <Gold paddingLeft={sortedData[index].data.total < goldPoints ? '2px' : '10px'} paddingBottom={sortedData[index].data.total < goldPoints ? '10px' : '6px'}>{t("Gold")}</Gold>
                            <LazyImage src={`${ImageUrl}/images/Rewards/gold.png`} />
                            <ThirdClass marginTop={sortedData[index].data.total < goldPoints ? '10px' : '5px'} paddingLeft={sortedData[index].data.total < goldPoints ? 'none' : '2px'} marginLeft={sortedData[index].data.total < goldPoints ? '-5px' : 'none'}>{commaSeperator(goldPoints)}{this.props.t("pts")}</ThirdClass>
                          </GoldImg>
                          <FlagImg top={sortedData[index].data.total === 0 ? '-400px' : '-445px'} left={`calc(100% - ${ lang == 'fr' ? '50px' : '35px'})`}>
                            <Finished>{t("Finish")}</Finished>
                            <LazyImage src={`${ImageUrl}/images/NewRewardSection/finish-flag.png`} />
                            <FourClass>{commaSeperator(companyRewardsBarValues.finished)}{this.props.t("pts")}</FourClass>
                          </FlagImg>
                        </ProgressBar>
                      </MainProgressBar>
                      <ViewPointsDetails onClick={() => this.handleDetails(index)}>
                        <div>{this.props.t("View Point Details")}
                          {this.state.dropDown === index ? <img src='/public/images/viewUpArrow.png'></img> : <img src='/public/images/viewDownArrow.png'></img>}
                        </div>
                      </ViewPointsDetails>
                      <PointContent />
                    </NewProgressPointsV2>
                  </NewProgressCardV2> */}

                  <NewProgressCardV1 isBorder={"none"}>
                    <NewProgressContent isBorderRadius={"0px"} tierStyle={tierStyle}>
                      <div className='main_content'>
                        { dataRewards.data.total >= 0 &&
                      <div className="newImageData">
                        <ImageTag>
                          <LazyImage src={dataRewards.data.total >= companyRewardsBarValues.finished ?  `${ImageUrl}/images/Rewards/new-platinum.png` : dataRewards.data.total > goldPoints ? `${ImageUrl}/images/Rewards/new-gold.png` : dataRewards.data.total > silverPoints ? `${ImageUrl}/images/Rewards/new-silver.png` :  dataRewards.data.total > bronzePoints ? `${ImageUrl}/images/Rewards/new-bronze.png` : `${ImageUrl}/images/Rewards/new-no-badge.png` }/>
                        </ImageTag>
                      </div> 
                        }
                        <div className='main_point_class'>
                          <div className='point_class'>
                            <div className='total_value'>{t("Total Points")}</div>
                            <div className='total_point_value' style={{marginBottom:'10px'}}>{commaSeperator(dataRewards.data.total)}</div>
                            {/* <div className='border_line' /> */}
                            <div className='left_point' style={{ marginTop: '15px' }}><span className='earn_point'>{this.props.t('Year')+' ' + (sortedData.length - index)} - </span>{dataRewards.year}</div>
                          </div>
                        </div>
                      </div>
                    </NewProgressContent>
                    <NewProgressPoints style={{position:'relative'}}>
                      <MainProgressBar style={{position:'absolute',display:'flex', height:'100%',top:'15%'}}>
                        <ProgressBar width={Math.min(Math.max(getProgressWidth(dataRewards.data.total), 0), 100)} color={sortedData[index].data.total > silverPoints ? "#DA6C74" : sortedData[index].data.total > bronzePoints ? "#EFEFEF" : "#A57576"}>
                          <div className="progrss" />
                        </ProgressBar>
                      </MainProgressBar>
                      <div className="medals-container">
        
                        <TrophyImg margin={'0px 0px 0px 25px'}>
                          <LazyImage div={'image-container'} src={`${ImageUrl}/images/Rewards/new-bronze.png`} />
                          <TrophyLabel>Bronze</TrophyLabel>
                          <TrophyPoints>{commaSeperator(bronzePoints)} pts </TrophyPoints>
                        </TrophyImg>
        
                        <TrophyImg>
                          <LazyImage div={'image-container'} src={`${ImageUrl}/images/Rewards/new-silver.png`} />
                          <TrophyLabel>Silver</TrophyLabel>
                          <TrophyPoints>{commaSeperator(silverPoints)} pts</TrophyPoints>
                        </TrophyImg>
        
                        <TrophyImg>
                          <LazyImage div={'image-container'} src={`${ImageUrl}/images/Rewards/new-gold.png`} />
                          <TrophyLabel>Gold </TrophyLabel>
                          <TrophyPoints>{commaSeperator(goldPoints)} pts</TrophyPoints>
                        </TrophyImg>
        
                        <TrophyImg margin={'0px -3px 0px 0px'}>
                          <LazyImage div={'image-container'} src={`${ImageUrl}/images/Rewards/new-platinum.png`} />
                          <TrophyLabel>Platinum</TrophyLabel>
                          <TrophyPoints>{commaSeperator(companyRewardsBarValues.finished)} pts</TrophyPoints>
                        </TrophyImg>
        
                      </div>
                      <PointContent />
                      <ViewPointsDetails onClick={() => this.handleDetails(index)} style={{top:'17px', left:'-39px'}}>
                        <div>{this.props.t("View Point Details")}
                          {this.state.dropDown === index ? <img src='/public/images/viewUpArrow.png'></img> : <img src='/public/images/viewDownArrow.png'></img>}
                        </div>
                      </ViewPointsDetails>
                    </NewProgressPoints>
                  </NewProgressCardV1>

                  {this.state.dropDown === index && <CategoryContainer>
                    {this.categoryArray(sortedData.indexOf(dataRewards)).map((category, index) => (
                      <NewRewardCatagory category={category} key={index} history={this.props.history} getIndex={index} />
                    ))}
                  </CategoryContainer>}
                </Layout>
              )})}
          </div>: 
          ( (selectedTab === 2 || selectedTab === 3 || selectedTab === 4) && !userProfileDetails ? (
            <Waiting />
          ) : selectedTab === 4 ? (
            <BucketCaps rewardPeriodId={userProfileDetails?.reward_period_id} />
          ) : selectedTab === 2 ? (
            userProfileDetails.is_new_rewards ? (
              <CompanyRewardDetails userId={userId} />
            ) : (
              <CompanyRewardsV2 userId={userId} />
            )
          ) : selectedTab === 3 ? (
            userProfileDetails.is_new_rewards ? (
              <RewardDetailsPage history={history} companyId={userCompany.id} />
            ) : (
              <NewRewardData history={history} companyId={userCompany.id} />
            )
          ) : null) }
       

        {this.state.showCongratsOverlay 
          && (
            <>
              {/* Loader Backdrop */}
              <Congrats />
              <CongratulationPopup UserName={UserName} show={this.state.showCongratsOverlay} onCancel={this.closeCongrats} SpotPointsEarned={SpotPointsEarned} SpotPointsDescription={SpotPointsDescription} />
            </>
          )}
      </div>
    );
  }
}

UserAcheivementData.propTypes = {
  monthlyRewardPoint: PropTypes.number,
  fitnessDetails: PropTypes.array,
  socialDetails: PropTypes.array,
  wellnessDetails: PropTypes.array,
  educationDetails: PropTypes.array,
  bonusWellness: PropTypes.array,
  bonusSocial: PropTypes.array,
  getUserRewardDetails: PropTypes.func,
  history: PropTypes.object,
  bonusFitness: PropTypes.array,
  bonusEducation: PropTypes.array,
  t: PropTypes.func,
  getCompanyRewardTierAPI: PropTypes.func,
  companyRewardsBarValues: PropTypes.array,
  companyId: PropTypes.number,
  getHistoryRewardPoints: PropTypes.func,
  getUserRewardHistoryDetails: PropTypes.func,
  userId: PropTypes.number,
  rewardData: PropTypes.array,
  userRewardHistoryDetails: PropTypes.array,
  created_at: PropTypes.number,
  userCompany:PropTypes.object,
  brandingColor:PropTypes.string,
  reward:PropTypes.object,
  user:PropTypes.object,
};

const mapStateToProps = (state) => ({
  reward: state.wellnessDashboard.reward,
  monthlyRewardPoint: state.wellnessDashboard.monthlyRewardPoint,
  fitnessDetails: state.wellnessDashboard.fitnessDetails,
  socialDetails: state.wellnessDashboard.socialDetails,
  wellnessDetails: state.wellnessDashboard.wellnessDetails,
  educationDetails: state.wellnessDashboard.educationDetails,
  bonusWellness: state.wellnessDashboard.bonusWellness,
  bonusSocial: state.wellnessDashboard.bonusSocial,
  bonusFitness: state.wellnessDashboard.bonusFitness,
  bonusEducation: state.wellnessDashboard.bonusEducation,
  companyRewardsBarValues: state.wellnessDashboard.companyRewardsBarValues,
  userId: state.profileData.userId,
  rewardData: state.wellnessDashboard.rewardData,
  created_at: state.profileData.user,
  userRewardHistoryDetails: state.wellnessDashboard.userRewardHistoryDetails,
  userCompany: state.profileData.userCompany,
  user: state.profileData.user,
  brandingColor:state.wellnessDashboard.brandingColor,
});

const mapDispathcToProps = (dispatch) => ({
  getUserRewardHistoryDetails: (userId, year) => dispatch(getUserRewardHistoryDetails(userId, year)),
  getCompanyRewardTierAPI: (companyId) => dispatch(getCompanyRewardTierAPI(companyId)),
  getHistoryRewardPoints: (userId, year) => dispatch(getHistoryRewardPoints(userId, year))
})

export default connect(mapStateToProps, mapDispathcToProps)(withTranslation()(UserAcheivementData));